<template>
    <div id="fd-zjxx">
        <my-title the-title="证据信息"/>
            <van-cell-group class="fd-com-scroll">
                <van-field
                    v-model="formData.nZjlxTxt"
                    class="special-readonly"
                    required
                    clearable
                    readonly
                    label="证据类型"
                    right-icon="arrow"
                    placeholder="请选择证据类型"
                    @click="showZjbqsx = true"
                ></van-field>
                <van-popup v-model="showZjbqsx" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="codeZjList"
                        :default-index="0"
                        @cancel="showZjbqsx = false"
                        @confirm="onSxsmConfirm"
                    ></van-picker>
                </van-popup>
                <van-field v-model.lazy.trim="formData.cZjmc" required label="证据名称" placeholder="请输入证据名称"/>
                <van-field
                    required
                    readonly
                    label="原件原物">
                    <van-radio-group v-model="formData.nYjwj" slot="input">
                        <van-radio name="1">
                            是
                        </van-radio>
                        <van-radio name="2">
                            否
                        </van-radio>
                    </van-radio-group>
                </van-field>
                <van-field v-model.lazy.trim="formData.cZjly" required label="证据来源" placeholder="证据来源"/>
                <!--保全开始日期-->
                <van-field
                    v-model="formData.dBqksrq"
                    class="special-readonly"
                    required
                    clearable
                    readonly
                    label="保全开始日期"
                    right-icon="arrow"
                    placeholder="请选择保全开始日期"
                    @click="showBqksrq = true"
                ></van-field>
                <van-popup v-model="showBqksrq" position="bottom">
                    <van-datetime-picker v-model="bqksrqCurrentDate" type="date" @confirm="onBqrqConfirm('1')" @cancel="onBqrqcancelFn('1')" />
                </van-popup>
                <!-- 保全结束日期-->
                <van-field
                    v-model="formData.dBqjsrq"
                    class="special-readonly"
                    required
                    clearable
                    readonly
                    label="保全结束日期"
                    right-icon="arrow"
                    placeholder="请选择保全结束日期"
                    @click="showBqjsrq = true"
                ></van-field>
                <van-popup v-model="showBqjsrq" position="bottom">
                    <van-datetime-picker v-model="bqjsrqCurrentDate" type="date"  @confirm="onBqrqConfirm('2')" @cancel="onBqrqcancelFn('2')" />
                </van-popup>
                <van-field
                    class="fd-textarea"
                    type="textarea"
                    rows="2"
                    show-word-limit
                    autosize
                    :rules="[{ required: true, message: '请输入证据说明' }]"
                    v-model="formData.cSm"
                    label="证据说明"
                    maxlength="200"
                    placeholder="请输入证据说明"
                />
            </van-cell-group>

            <div class="fd-com-btn-container">
                <van-button
                    v-if="formData.zjxxId"
                    type="info"
                    round
                    @click="addAndReturn"
                >
                    确定
                </van-button>
                <van-button
                    v-if="!formData.zjxxId"
                    type="info"
                    round
                    plain
                    @click="addAndReturn"
                >
                    添加
                </van-button>
                <van-button
                    v-if="!formData.zjxxId"
                    type="info"
                    round
                    @click="addAndContinue"
                >
                    确认并继续添加
                </van-button>
            </div>
    </div>
</template>

<script>
import MyTitle from '../../../components/common/myTitle';
import {mapState, mapGetters} from "vuex";
import validate from "@/utils/validator/validator";
import {addXcxZj, getXcxZj, saveJcbqData} from '../../../api/guarantee';
import {typeXwbqsx, zjlxType} from "../../../filters/index";
import {czjmcRule, czjlyRule, dBqksrqRule, dBqjsrqRule, csxsmRule} from "@/utils/validator/rules";
import {getId} from "@/api/common";

export default {
    name: "addXwxx",
    components: {
        MyTitle
    },
    data() {
        return {
            bqksrqCurrentDate: new Date(),
            bqjsrqCurrentDate: new Date(),
            checked: '1',
            checkRadioFlag: false,
            showBqksrq:false,
            showBqjsrq:false,
            formData:{
                zjxxId: null, // id
                // nZjlx: 1,
                nZjlxTxt:'当事人陈述',
                // cZjsm:'',
                // cZjmc: '',
                nYjwj: '1',
                nYjwjTxt: '是',
                // cZjly: ''

                nZjlx: 1,
                cZjmc: null,
                // nYjwj: 1,
                cZjly: null,
                cSm: null,
                dBqksrq:'',
                dBqjsrq:'',
                cid: null, // 证据信息主键
                cjbid: null, // 解除保全id
                cbqid: null, // 证据保全id
            },
            myRules: [],
            showZjbqsx:false,
            codeZjList: [
                { text: '当事人陈述', value: '1' },
                { text: '被告人陈述', value: '2' },
                { text: '犯罪嫌疑人、被告人供述和辩解', value: '3' },
                { text: '书证', value: '4' },
                { text: '物证', value: '5' },
                { text: '视听资料', value: '6' },
                { text: '电子数据', value: '7' },
                { text: '证人证言', value: '8' },
                { text: '鉴定意见', value: '9' },
                { text: '勘验、检查、辨认、侦查实验等笔录', value: '10' },
                { text: '其他', value: '255' },
            ]
        };
    },
    computed: {
        ...mapGetters(['jcbqzjxxData']),
    },
    methods: {
        onBqrqConfirm: function(item){
            if (item === '1') {
                this.formData.dBqksrq = this.timeFormat(this.bqksrqCurrentDate);
                this.showBqksrq = false;
            }
            if (item === '2') {
                this.formData.dBqjsrq = this.timeFormat(this.bqjsrqCurrentDate);
                this.showBqjsrq = false;
            }
        },
        onBqrqcancelFn(item) {
            if (item === '1') {
                this.showBqksrq = false;
            }
            if (item === '2') {
                this.showBqjsrq = false;
            }
        },
        timeFormat(currentTime) { // 时间格式化 2019-09-08
            let time =  new Date(currentTime);
            let year = time.getFullYear();
            let month = this.showTime(time.getMonth() + 1);
            let day = this.showTime(time.getDate());
            return year + '-' + month + '-' + day
        },
        // 封装一个不够两位数就补零的函数
        showTime(t) {
            let time
            time = t >= 10 ? t : '0' + t
            return time
        },
        onSxsmConfirm: function(item) {
            this.formData.nZjlx = item.value;
            this.formData.nZjlxTxt = item.text;
            this.showZjbqsx = false;
            console.log('--onSxsmConfirm 111',item);
            console.log('--onSxsmConfirm 222',this.formData);
        },
        initForm() {
            let obj = {
                nZjlx: 1,
                cZjmc: null,
                // nYjwj: 1,
                cZjly: null,
                cSm: null,
                dBqksrq:'',
                dBqjsrq:'',
                cid: null, // 证据信息主键
                cjbid: null, // 解除保全id
                cbqid: null, // 证据保全id
            }
            for (let key in obj) {
                this.formData[key] = obj[key]
            }
        },
        //组装提交数据
        params() {
            let jbJbxx = [];
            let jcbqzjxx = [];
            console.log(this.jcbqzjxxData)
            if (this.jcbqzjxxData.length > 0 ) {
                jcbqzjxx = this.jcbqzjxxData
            }
            jcbqzjxx.push(this.formData)
            jbJbxx = JSON.parse(sessionStorage.getItem('jcbqjbxx'))
            return {
                jbJbxx: jbJbxx,
                jbCcxxs: [],
                jbZjxxs: jcbqzjxx,
                jbXwxxs: [],
            }
        },
        validateFormData(){
            // 校验规则
            let descriptor={};
            descriptor.cZjmc = czjmcRule;
            descriptor.cZjly =czjlyRule
            descriptor.dBqksrq = dBqksrqRule;
            descriptor.dBqjsrq = dBqjsrqRule;
            return validate(descriptor, this.formData);
        },
        async onSubmit(fn){
            let params = await this.params()
            // this.formData.cjbid = sessionStorage.getItem('cId');
            // this.formData.cbqid = sessionStorage.getItem('bqid');
            this.formData.cjbid = this.$route.query.cId
            this.formData.cbqid = this.$route.query.bqid
            var zjxxId = sessionStorage.getItem("bqZjxxId");
            // sessionStorage.setItem("jczjxxItem", JSON.stringify(zjxxItem));
            // sessionStorage.setItem("bqZjxxId", cid);
            if (zjxxId) {
                this.formData.cid = zjxxId;
            } else {
                this.formData.cid = await this.myId(0);
            }
            console.log('--数据提交 111',this.formData,params);
            this.validateFormData().then(() => {
                saveJcbqData(params).then((res)=>{
                    console.log('--addXcxXw 123',res);
                    if (res.code ===200) {
                        this.$notify({'type': 'success', 'message': '操作成功'});
                    } else {
                        this.$notify(res.message);
                    }
                    fn();
                }).catch((error) => {  console.log(error) });
            });
        },
        addAndReturn(){
            this.onSubmit(()=>{
                this.$router.push({
                    path: '/relievePreservationNew',
                    query: {
                        bqid: this.$route.query.bqid,
                        cId: this.$route.query.cId,
                    }
                })
            });
        },
        addAndContinue(){
            this.onSubmit(()=> {
                // debugger
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            });
        },
        initData(){
            var data=this.formData;
            this.formData.nZjlx = data.nZjlx;
            this.formData.nZjlxTxt = zjlxType(data.nZjlx);
            this.formData.cZjmc = data.cZjmc;
            this.formData.nYjwj = data.nYjwj.toString();
            this.formData.cZjly = data.cZjly;
            this.formData.cSm=data.cSm;
            this.formData.dBqksrq = data.dBqksrq;
            // this.formData.dbqjsrq = dateFormat(data.dbqjsrq, "yyyy-MM-dd");
            this.formData.dBqjsrq = data.dBqjsrq;
        },
        /**
         * 获取id
         * */
        myId(i) {
            return new Promise((resolve, reject) => {
                i++
                if (i > 3) {
                    this.$notify('系统错误，请重试!');
                    reject();
                } else {
                    getId().then((res) => {
                        resolve(res.data)
                    }).catch(() => {
                        return this.myId(i);
                    })
                }
            })
        },
    },
    created() {
        // this.myRules = new Rules(this.formData)
        console.log('--created zjxx');
        var jczjxxItem = sessionStorage.getItem("jczjxxItem");
        // if(jcxwxxItem){
        //     this.formData = JSON.parse(jcxwxxItem);
        //     this.initData();
        // }
        var zjxxId = sessionStorage.getItem("bqZjxxId");
        if(jczjxxItem){
            this.formData = JSON.parse(jczjxxItem);
            this.formData.zjxxId = zjxxId;
            this.initData();
        }
    },
    mounted() {
        this.timeFormat(new Date());
    },
    // 路由跳转之前保存当前滚动条的位置。
    beforeRouteLeave(to, from, next) {
        sessionStorage.removeItem("jczjxxItem");
        sessionStorage.removeItem("bqZjxxId");
        next();
    },
}
</script>

<style lang="less" scoped>

#fd-zjxx{
    width: 100%;
    height: 100%;
    overflow: hidden;

        .fd-textarea{
            height: auto;
        }
}
</style>
